import { Link } from "react-router-dom";
import { HeaderLogo } from "@/components/AnimatedLogo";
import { SimpleLegalFooter } from "@/components/LegalFooter";

const Section = ({ title, children }) => (
  <section className="mb-8">
    <h2 className="text-lg font-bold text-[#102692] mb-2">{title}</h2>
    <div className="text-gray-700 leading-relaxed space-y-2">{children}</div>
  </section>
);

const LegalLayout = ({ title, children, testid }) => (
  <div className="min-h-screen bg-gradient-to-b from-gray-50 to-white">
    <header className="bg-white/80 backdrop-blur-sm border-b">
      <div className="max-w-4xl mx-auto px-4 py-3">
        <Link to="/"><HeaderLogo theme="contact" size="sm" showName={false} dark={false} /></Link>
      </div>
    </header>
    <main className="max-w-4xl mx-auto px-4 py-10" data-testid={testid}>
      <h1 className="text-3xl font-bold text-gray-900 mb-8">{title}</h1>
      <div className="bg-white rounded-3xl shadow-xl p-6 md:p-10">{children}</div>
    </main>
    <SimpleLegalFooter />
  </div>
);

export function MentionsLegales() {
  return (
    <LegalLayout title="Mentions légales" testid="mentions-legales-page">
      <Section title="Éditeur du site">
        <p>LS ASSUR, SAS, exploitant la marque Jyvis Assurances</p>
        <p>Siège social : 10 rue de la Paix, 75002 Paris</p>
        <p>Agence : 47 rue Jean Jaurès, 93200 Saint-Denis</p>
        <p>RCS Paris 993 855 527</p>
      </Section>
      <Section title="Activité réglementée">
        <p>Courtier en assurance (COA) immatriculé à l'ORIAS sous le n° 26005663 (<a href="https://www.orias.fr" target="_blank" rel="noreferrer" className="text-[#102692] underline">www.orias.fr</a>).</p>
        <p>Autorité de contrôle : ACPR (Autorité de Contrôle Prudentiel et de Résolution), 4 place de Budapest, CS 92459, 75436 Paris Cedex 09.</p>
      </Section>
      <Section title="Médiation">
        <p data-testid="mentions-mediateur">La Médiation de l'Assurance – TSA 50110 – 75441 Paris Cedex 09 – <a href="https://www.mediation-assurance.org" target="_blank" rel="noopener noreferrer" className="underline">www.mediation-assurance.org</a></p>
      </Section>
      <Section title="Réclamations">
        <p><a href="mailto:contact@jyvis-assurances.com" className="text-[#102692] underline">contact@jyvis-assurances.com</a> – <a href="tel:0148209827" className="text-[#102692] underline">01 48 20 98 27</a></p>
      </Section>
      <Section title="Hébergeur">
        <p data-testid="mentions-hebergeur">Emergent (plateforme d'hébergement du site) – <a href="https://emergent.sh" target="_blank" rel="noopener noreferrer" className="underline">emergent.sh</a></p>
      </Section>
    </LegalLayout>
  );
}

export function PolitiqueConfidentialite() {
  return (
    <LegalLayout title="Politique de confidentialité" testid="privacy-page">
      <Section title="Responsable du traitement">
        <p>LS ASSUR, SAS exploitant la marque Jyvis Assurances, 10 rue de la Paix, 75002 Paris – RCS Paris 993 855 527.</p>
      </Section>
      <Section title="Données collectées">
        <p>Via les formulaires de contact, de devis et les calculateurs : nom, prénom, téléphone, email, informations sur votre véhicule (immatriculation, marque, modèle), votre logement, votre entreprise (SIREN, activité, chiffre d'affaires), vos antécédents d'assurance et les documents que vous nous transmettez (relevé d'information).</p>
        <p>Lors d'une souscription, le paiement est traité par notre prestataire de paiement sécurisé ; nous ne conservons pas vos données de carte bancaire.</p>
      </Section>
      <Section title="Finalités">
        <p>Établir vos devis, vous recontacter, gérer la souscription et le suivi de vos contrats, assurer la gestion des paiements et répondre à vos demandes.</p>
      </Section>
      <Section title="Durée de conservation">
        <p>Les données des prospects sont conservées 3 ans à compter du dernier contact. Les données des clients sont conservées pendant la durée du contrat puis pendant les durées légales de prescription applicables.</p>
      </Section>
      <Section title="Vos droits">
        <p>Vous disposez d'un droit d'accès, de rectification, de suppression, d'opposition et de limitation du traitement de vos données. Pour les exercer, écrivez-nous à <a href="mailto:contact@jyvis-assurances.com" className="text-[#102692] underline">contact@jyvis-assurances.com</a>.</p>
        <p>Vous pouvez également introduire une réclamation auprès de la CNIL (www.cnil.fr).</p>
      </Section>
      <Section title="Cookies">
        <p>Le site utilise des cookies nécessaires à son fonctionnement et, avec votre accord, des cookies de mesure d'audience. Vous pouvez modifier vos choix à tout moment via le lien « Gestion des cookies » en bas de page.</p>
      </Section>
    </LegalLayout>
  );
}
